import { useEffect, useMemo, useState } from 'react';
import './index.css'
import { ImageUrl, orderhistoryList, postApiCall } from '../../API/baseUrl';
import ToastMessage from '../../utils/ToastMessage';
import { useNavigate } from 'react-router-dom';
import Loader from '../../components/loader';
import moment from 'moment';
import Empty from '../emptypage/emptyCart';
import emptyorderlist from "../../Assect/emptyorder.jpg"
import {
    Box,
    Typography,
    Stack,
    Paper,
    Pagination,
    CircularProgress,
    Chip,
  } from '@mui/material';
  import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
// import Pagination from '@mui/material/Pagination';
import { makeStyles } from '@material-ui/core/styles';
import TopPageImage from '../../components/toppageimage';


const Orders = () => {
    const navigate = useNavigate();
    const user_id = localStorage.getItem("user_id")
    const [orderHistory, setOrderHistory] = useState([])
    const [pending, setPending] = useState(false)
    const [pageCount, setPageCount] = useState(0)
    const [currentPage, setcurrentPage] = useState(1)

    const getOrderhistory = async () => {
        setPending(true)
        try {
            const result = await postApiCall(orderhistoryList, {

                userId: user_id,
                limit: 5,
                offset: currentPage,
                search: "",
                column_name: "",
                sort_by: ""
            })
            if (result?.data?.status) {
                setPending(false)
                setOrderHistory(result?.data?.data)
                setPageCount(result?.data?.total_count)


            } else {
                ToastMessage("error", result.data.message);
            }
        } catch (error) {
        }
        finally {
            setPending(false)
        }
    }

    useEffect(() => {
        getOrderhistory()
    }, [currentPage])

    const handleDetails = async (id) => {
        navigate(`/orderdetails/${id}`)
    }

    const handleChange = (event, value) => {
        setcurrentPage(value);
    };


    const statusColors = {
        Delivered: "success",
        Accepted: "info",
        Dispatched: "warning",
        Cancelled: "error",
      };
    return (
   <>
   
   <Box px={2} py={4}>
   {pending ? (
        <Loader />
      ) : (
        <Box className="orderhistory_container" sx={{ px: { xs: 2, md: 4 }, py: 2 }}>
          {orderHistory?.length ? (
            <Stack spacing={2}>
              {orderHistory.map((val, index) => (
                <Paper
                  key={index}
                  elevation={2}
                  sx={{
                    p: 2,
                    borderRadius: 2,
                    transition: "0.3s",
                    cursor: "pointer",
                    "&:hover": {
                      backgroundColor: "#f5f5f5",
                      boxShadow: 4,
                    },
                  }}
                  onClick={() => handleDetails(val.order_id_fk)}
                >
                  <Stack
                    direction={{ xs: "column", sm: "row" }}
                    justifyContent="space-between"
                    spacing={2}
                  >
                    <Box>
                      <Typography variant="subtitle2" color="text.secondary">
                        Order ID
                      </Typography>
                      <Typography variant="body1">{val.product_order_id}</Typography>
                    </Box>

                    <Box>
                      <Typography variant="subtitle2" color="text.secondary">
                        Order On
                      </Typography>
                      <Typography variant="body1">
                        {moment(val.Date).format("MMMM Do YYYY")}
                      </Typography>
                    </Box>

                    <Box>
                      <Typography variant="subtitle2" color="text.secondary">
                        Order Status
                      </Typography>
                      <Chip
                        label={val.orderStatus}
                        color={statusColors[val.orderStatus] || "default"}
                        size="small"
                      />
                    </Box>

                    <Box>
                      <Typography variant="subtitle2" color="text.secondary">
                        Order Total
                      </Typography>
                      <Typography variant="body1">
                        <CurrencyRupeeIcon sx={{ fontSize: "15px", verticalAlign: "middle" }} />
                        {Number(val.total_order_amount).toFixed(2)}
                      </Typography>
                    </Box>
                  </Stack>
                </Paper>
              ))}

              <Pagination
                count={Math.ceil(pageCount / 5)}
                page={currentPage}
                onChange={handleChange}
                color="primary"
                sx={{ alignSelf: "center", mt: 2 }}
              />
            </Stack>
          ) : (
            <Box textAlign="center" mt={4}>
              <Empty image={emptyorderlist} btn="Shop Now" />
            </Box>
          )}
        </Box>
      )}
    </Box> 
   </>
    )
}
export default Orders